import RedPacket from './index';
import RedAudit from './auditRed';
import index from './routeIndex';
import GetRecord from './getRecord';

export default {
    path: '/home/red',
    component: index,
    children: [
        {
            path: '/home/red/packet',
            component: RedPacket
        },
        {
            path: '/home/red/audit',
            component: RedAudit
        },
        {
            path: '/home/red/record',
            name: 'redDetail',
            component: GetRecord
        }
    ]
   }

